interface Props {
  className?: string
}

export default function Divider({ className = '' }: Props): React.ReactElement {
  return <div className={`w-full h-1 bg-purple ${className}`} />
}
